<div class="container shippn-homepage-container" style="margin-top:20px;">
    <div class="row">
        <div style="margin-bottom: 40px;" class="col-md-12 form-mobile-positioning">
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="header-underline-black-left"
                            style="font-size: 22px;font-weight: bold;margin-bottom: 27px;color: black;">
                            Shipper Network: Domestic & International Shipping</h1>
                        <p
                            style="color: black;text-align: left;font-size: 16px;font-weight: normal;margin-bottom: 20px;">
                            Join
                            Shippn Shipper Network (ShipNet) and provide your services to millions of shoppers around
                            the world</p>
                    </div>
                </div>

                <div class="shipper-network-form-box">
                    <div class="row shipper-network-form-element">
                        <div class="col-md-12">
                            <p
                                style="color: black;text-align: left;font-size: 16px;font-weight: bold;margin-bottom: 0px;">
                                Your Company provides the following shipping services:</p>

                            <div class="row">
                                <div style="margin-top: 10px;" class="col-md-4 col-4 shipper-btn-wrapper">
                                    <button (click)="firstSelection = 1"
                                        [ngClass]="{'btn-secondary':firstSelection != 1, 'shippn-from-to-area-go-btn': firstSelection == 1}"
                                        style="width:100%;font-size: 14px;font-weight: normal;height: 38px;margin-right: 20px;"
                                        class="btn shipper-btn shippn-from-to-area-go-btn">Domestic</button>
                                </div>
                                <div style="margin-top: 10px;" class="col-md-4 col-4 shipper-btn-wrapper">
                                    <button (click)="firstSelection = 2"
                                        [ngClass]="{'btn-secondary':firstSelection != 2, 'shippn-from-to-area-go-btn': firstSelection == 2}"
                                        style="width:100%;font-size: 14px;font-weight: normal;height: 38px;margin-right: 20px;"
                                        class="btn shipper-btn shippn-from-to-area-go-btn">International</button>
                                </div>
                                <div style="margin-top: 10px;" class="col-md-4 col-4 shipper-btn-wrapper">
                                    <button (click)="firstSelection = 3"
                                        [ngClass]="{'btn-secondary':firstSelection != 3, 'shippn-from-to-area-go-btn': firstSelection == 3}"
                                        style="width:100%;font-size: 14px;font-weight: normal;height: 38px;"
                                        class="btn shipper-btn shippn-from-to-area-go-btn">Both</button>
                                </div>
                            </div>
                        </div>

                        <div style="margin-top: 20px;" class="col-md-12">
                            <p
                                style="color: black;text-align: left;font-size: 16px;font-weight: bold;margin-bottom: 0px;">
                                Type of services provided:</p>

                            <div class="row">
                                <div style="margin-top: 10px;" class="col-md-4 col-4 shipper-btn-wrapper">
                                    <button (click)="secondSelection = 1"
                                        [ngClass]="{'btn-secondary':secondSelection != 1, 'shippn-from-to-area-go-btn': secondSelection == 1}"
                                        style="width:100%;font-size: 14px;font-weight: normal;height: 38px;margin-right: 20px;"
                                        class="btn shipper-btn shippn-from-to-area-go-btn">Express shipping</button>
                                </div>
                                <div style="margin-top: 10px;" class="col-md-4 col-4 shipper-btn-wrapper">
                                    <button (click)="secondSelection = 2"
                                        [ngClass]="{'btn-secondary':secondSelection != 2, 'shippn-from-to-area-go-btn': secondSelection == 2}"
                                        style="width:100%;font-size: 14px;font-weight: normal;height: 38px;margin-right: 20px;"
                                        class="btn shipper-btn shippn-from-to-area-go-btn">Economy</button>
                                </div>
                                <div style="margin-top: 10px;" class="col-md-4 col-4 shipper-btn-wrapper">
                                    <button (click)="secondSelection = 3"
                                        [ngClass]="{'btn-secondary':secondSelection != 3, 'shippn-from-to-area-go-btn': secondSelection == 3}"
                                        style="width:100%;font-size: 14px;font-weight: normal;height: 38px;"
                                        class="btn shipper-btn shippn-from-to-area-go-btn">Both</button>
                                </div>
                            </div>
                        </div>

                        <div style="margin-top: 20px;" class="col-md-12">
                            <p
                                style="color: black;text-align: left;font-size: 16px;font-weight: bold;margin-bottom: 0px;">
                                Do you offer storage or package handling services:</p>

                            <div class="row">
                                <div style="margin-top: 10px;" class="col-md-4 col-4 shipper-btn-wrapper">
                                    <button (click)="thirdSelection = 1"
                                        [ngClass]="{'btn-secondary':thirdSelection != 1, 'shippn-from-to-area-go-btn': thirdSelection == 1}"
                                        style="width:100%;font-size: 14px;font-weight: normal;height: 38px;margin-right: 20px;"
                                        class="btn shipper-btn shippn-from-to-area-go-btn">Storage</button>
                                </div>
                                <div style="margin-top: 10px;" class="col-md-4 col-4 shipper-btn-wrapper">
                                    <button (click)="thirdSelection = 2"
                                        [ngClass]="{'btn-secondary':thirdSelection != 2, 'shippn-from-to-area-go-btn': thirdSelection == 2}"
                                        style="width:100%;font-size: 14px;font-weight: normal;height: 38px;margin-right: 20px;"
                                        class="btn shipper-btn shippn-from-to-area-go-btn">Package handling</button>
                                </div>
                                <div style="margin-top: 10px;" class="col-md-4 col-4 shipper-btn-wrapper">
                                    <button (click)="thirdSelection = 3"
                                        [ngClass]="{'btn-secondary':thirdSelection != 3, 'shippn-from-to-area-go-btn': thirdSelection == 3}"
                                        style="width:100%;font-size: 14px;font-weight: normal;height: 38px;"
                                        class="btn shipper-btn shippn-from-to-area-go-btn">Both</button>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>

                    <form ngNativeValidate [formGroup]="form" (ngSubmit)="onSubmit(form)"
                        class="shipper-network-form-element">
                        <div class="col-md-12 small-device-form-pad-fix company-name">
                            <!--Company Name-->
                            <p
                                style="color: black;text-align: left;font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                                Company Name</p>
                            <div class="row">
                                <div class="col-md-12">
                                    <input type="text" formControlName="companyName"
                                        [ngClass]="{'shippn-border-red':form.get('companyName').touched && form.get('companyName').invalid}"
                                        placeholder=""
                                        class="form-control form-control-sm shippn-input shipper-network-input">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 small-device-form-pad-fix" style="margin-top: 20px">
                            <!--Phone Number -->
                            <p
                                style="color: black;text-align: left;font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                                Phone Number</p>

                            <div class="row">
                                
                                <div class="col-md-12">

                                    <div class="phone-input-group" [ngClass]="{'shippn-border-red':form.get('phoneNumber').touched && form.get('phoneNumber').invalid}">
                                        <div class="country_flag" (click)="phoneCodeCountrySelection = !phoneCodeCountrySelection;" style="padding: 4px 10px">
                                            <img async
                                                src="https://www.shippn.com/assets/img/flags/{{phoneSelectedCountryFlag}}"
                                                alt="country flag" width="30px">
                                            <i class="fas fa-chevron-up" [ngClass]="phoneCodeCountrySelection == false ? 'rotate-180deg': 'rotate-0deg'"></i>
                                        </div>
                                        <div class="phone-input">
                                            <div class="phone-number-before"
                                                (click)="phoneCodeCountrySelection = !phoneCodeCountrySelection">
                                                +{{phoneSelectedCountryCode}}
                                            </div>
                                            <input type="number" formControlName="phoneNumber"
                                            placeholder="" class="form-control form-control-sm phone-input" onwheel="this.blur()">
                                        </div>
                                    </div>


                                    <div class="phone-country-code-selection"
                                        *ngIf="phoneCodeCountrySelection == true" [ngClass]="phoneCodeCountrySelection == true ? 'stage-in': 'stage-out'">
                                        <div class="phone-input-country-search">
                                            <input type="text" class="form-control" [(ngModel)]="searchCountryName"
                                                [ngModelOptions]="{standalone: true}"
                                                placeholder="Search for countries">
                                        </div>
                                        <div class="phone-input-country-list">
                                            <ul
                                                *ngIf="(countries | countrySearch:searchCountryName) as countryList;">
                                                <li *ngFor="let country of countryList; let index = index;"
                                                    (click)="selectPhoneCountry(country)">
                                                    <img async
                                                        src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                                                        alt="country flag" width="25px">
                                                    {{country.name}} (+{{country.country_phone_code}})
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 small-device-form-pad-fix" style="margin-top: 20px">
                            <!--Email-->
                            <p
                                style="color: black;text-align: left;font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                                Email</p>
                            <div class="row">
                                <div class="col-md-12">
                                    <input type="email" formControlName="email"
                                        [ngClass]="{'shippn-border-red':form.get('email').touched && form.get('email').invalid}"
                                        placeholder=""
                                        class="form-control form-control-sm shippn-input shipper-network-input">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 shipper-network-submit">
                            <!--Submit-->
                            <div class="row">
                                <div class="col-md-12 shipper-network-submit-btn-wrapper">
                                    <button style="font-size: 14px;font-weight: normal;height: 38px;"
                                        class="btn shippn-from-to-area-go-btn "
                                        [disabled]="!form.valid || firstSelection < 1 || secondSelection < 1 || thirdSelection < 1">Join
                                        Now!</button>
                                </div>
                            </div>
                        </div>
                    </form>

                </div>


            </div>
        </div>
    </div>

</div>